import React from 'react';

import tesla from '../../imgs/telsa-image.png';

export default class Auto3 extends React.Component {
  render() {
    return (
      <div className='typography-container'>
	<h1>Современный автомобиль</h1>
<p>
	На сегодняшний день общее количество автомобилей во всех странах составляет
	около одного миллиарда единиц (80–85% из них легковые автомобили). При этом
	100% всех автомобилей имеют двигатели внутреннего сгорания, работающие на
	углеводородном топливе - бензине, дизельном топливе, метаноле или горючих
	газах.
</p>
<p>
	Запасы углеводородного топлива в недрах земли с течением времени постоянно
	уменьшаются, а открытие новых месторождений нефти и газа идет все более
	замедляющимися темпами.
</p>
<p>
	Этот дисбаланс между растущим количеством автомобилей и уменьшением
	количества топлива для их эксплуатации и является основным противоречием
	нашей эпохи. При этом увеличение количества автомобилей несет с собой еще
	одну проблему − ухудшение экологической ситуации в атмосфере земли.
	Особенно это касается больших мегаполисов, где концентрация автотранспорта
	на единицу площади очень велика.
</p>
<p>
	Поэтому разработчики автомобилей и двигателей все чаще обращаются к
	нетрадиционным путям повышения топливной экономичности и улучшения экологии
	автомобилей. Одним из самых перспективных направлений работ в этой области
	является создание автомобилей с гибридными (комбинированными)
	энергетическими установками.
</p>
<p>
	Электромобили — это экологически чистый аналог автомобиля с
	электродвигателем. Они работают без привычного для транспорта топлива,
	используя чистую и возобновляемую энергию электричества. В настоящий момент
	производители авто всего мира ежедневно работают над тем, чтобы улучшить
	качество и стандарты сферы электромобилей.
</p>
<p align='center'>
  <img src={tesla} className='responsive-img' alt='' />
</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/docs/Auto-3.js